// extracted by mini-css-extract-plugin
export default {"root":"wifi-module--root--87f84","icon":"wifi-module--icon--aaaf8","text":"wifi-module--text--116ff","link":"wifi-module--link--e2448"};